// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2yzXS","rootSmall":"AddTileButton_rootSmall__1O0_J"};